/*eslint-disable*/
import React, { Component, Suspense } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  CardHeader,
  Badge,
  Label,
  CardTitle,
} from "reactstrap";
import { Icon, Step } from "semantic-ui-react";
import CardResumen from "./DetailContainer";
const StepperEvent = React.lazy(() =>
  import("../../../../Components/StepperEvent")
);

class ToArrive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTotals: true,
      dataContainer: [],
      steps: [
        {
          label: "Booking request",
          value: "",
          id: 1,
          completed: false,
          order: 1,
          idStep: "step1",
          middleStep: "",
        },
        {
          label: "Booking Confirmation",
          value: "",
          id: 2,
          completed: false,
          order: 2,
          idStep: "step2",
          middleStep: "",
        },
        {
          label: "ATD",
          value: "",
          id: 4,
          completed: false,
          order: 4,
          idStep: "step4",
          middleStep: "",
        },
        {
          label: "ATA",
          value: "",
          id: 5,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
        },
        {
          label: "Out of Gate",
          value: "",
          id: 8,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
        },
        {
          label: "Empty Returned",
          value: "",
          id: 9,
          completed: false,
          order: 9,
          idStep: "step9",
          middleStep: "",
        },
      ],
    };
  }

  componentDidMount = () => {
    // this.props.steps.sort(function(a, b) {return a.order - b.order});

    this.setState({
      allSteps: this.props.allSteps,
      steps: this.props.steps,
      doEmbarque: this.props.data.ShipmentId,
      noContenedor: this.props.data.ContainerId,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    // nextProps.steps.sort(function(a, b) {return a.order - b.order});
    // nextProps.steps.sort(function (a, b) { return a.order - b.order });
    this.setState({
      dataContainer: nextProps.data,
      allSteps: nextProps.allSteps,
      steps: this.props.steps,
    });
  };

  render() {
    const { Logistics, loadingTotals, data, dataContainer } = this.state;
    return (
      <>
        <Row>
          <Col md={4} lg={4} sm={12} style={{ padding: "0px 15px 15px 15px" }}>
            <CardResumen
              data={dataContainer}
              getContainerId={this.props.getContainerId}
            >
              {" "}
            </CardResumen>
          </Col>
          <Col md={8} lg={8} sm={12}>
            <Card className="myCard" style={{ textAlign: "center" }}>
              <div>
                <CardBody>
                  <Label tag="h4" style={{ color: "black", textAlign: "left" }}>
                    Events
                  </Label>
                </CardBody>
              </div>
              <StepperEvent vertical={true} steps={this.state.steps}>
                {" "}
              </StepperEvent>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default ToArrive;
